/* ============================================================
   BONHEUR - Segunda foto al pasar el mouse
   BigStudio 2026

   EL PROBLEMA
   La tarjeta de Horizon es un slideshow de tres diapositivas que
   al pointerenter avanza a la segunda. Pero esa segunda imagen
   nace con loading="lazy" y el navegador NUNCA la pide: queda en
   complete=false y naturalWidth=0. Recien cuando el mouse entra
   arranca la peticion de red, asi que el cambio se ve como un
   hueco y despues un salto. En una pasteleria, donde la foto ES
   el producto, eso es lo peor que puede pasar.

   LA SOLUCION
   Pedir esa segunda foto ANTES, cuando la tarjeta se acerca a la
   pantalla, con prioridad baja para que no le quite ancho de
   banda a lo que se esta viendo. Cuando el mouse llega, la imagen
   ya esta decodificada y el cambio es instantaneo.

   LO QUE NO HACE
   - No se ejecuta en telefonos: sin mouse no hay hover, y ahi esta
     el 88,7% del trafico. Movil no paga ni un byte por esto.
   - No se ejecuta con ahorro de datos ni en redes 2G.
   - No toca la tercera imagen, que el hover no usa.
   - Si el archivo no carga, el sitio queda exactamente como estaba.
   ============================================================ */

(function () {
  'use strict';

  var MARGEN = '400px 0px';

  function hayMouse() {
    if (!window.matchMedia) return false;
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function redPobre() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    return /2g/.test(c.effectiveType || '');
  }

  if (!hayMouse() || redPobre()) return;

  function calentar(galeria) {
    if (!galeria || galeria.getAttribute('data-bh-tibia') === '1') return;
    galeria.setAttribute('data-bh-tibia', '1');

    var imgs = galeria.querySelectorAll('img');
    if (imgs.length < 2) return;

    var img = imgs[1];
    if (img.complete && img.naturalWidth > 0) return;

    try {
      img.fetchPriority = 'low';
    } catch (e) {}
    img.loading = 'eager';

    /* Empujon en paralelo. Cambiar loading en caliente no siempre
       dispara la descarga; una copia desprendida del documento la
       deja en la cache HTTP igual, y con el mismo srcset para que
       el navegador elija exactamente el archivo que va a pintar. */
    var pre = new Image();
    try {
      pre.fetchPriority = 'low';
    } catch (e) {}
    if (img.sizes) pre.sizes = img.sizes;
    if (img.srcset) pre.srcset = img.srcset;
    if (img.src) pre.src = img.src;
    if (pre.decode) {
      pre.decode().catch(function () {});
    }
  }

  var observador = null;
  if ('IntersectionObserver' in window) {
    observador = new IntersectionObserver(
      function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (entradas[i].isIntersecting) {
            calentar(entradas[i].target);
            observador.unobserve(entradas[i].target);
          }
        }
      },
      { rootMargin: MARGEN }
    );
  }

  function registrar(raiz) {
    var galerias = (raiz || document).querySelectorAll('.card-gallery');
    for (var i = 0; i < galerias.length; i++) {
      if (galerias[i].getAttribute('data-bh-visto') === '1') continue;
      galerias[i].setAttribute('data-bh-visto', '1');
      if (observador) observador.observe(galerias[i]);
      else calentar(galerias[i]);
    }
  }

  /* Red de seguridad: si el puntero llega antes que el observador,
     se pide en ese mismo instante. pointerover burbujea; pointerenter
     no. */
  document.addEventListener(
    'pointerover',
    function (e) {
      if (!e.target || !e.target.closest) return;
      calentar(e.target.closest('.card-gallery'));
    },
    { passive: true }
  );

  function arrancar() {
    registrar(document);

    /* Filtros de coleccion, paginacion y el editor de temas
       reemplazan tarjetas enteras. */
    if ('MutationObserver' in window) {
      var pendiente = false;
      new MutationObserver(function (mut) {
        if (pendiente) return;
        for (var i = 0; i < mut.length; i++) {
          if (mut[i].addedNodes.length) {
            pendiente = true;
            requestAnimationFrame(function () {
              pendiente = false;
              registrar(document);
            });
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    registrar(e.target);
  });
})();
